export let STREAM_STATUSES = /*#__PURE__*/function (STREAM_STATUSES) {
  STREAM_STATUSES["READY"] = "READY";
  STREAM_STATUSES["PENDING"] = "PENDING";
  return STREAM_STATUSES;
}({});
export let LIVE_VIDEO_STATUS = /*#__PURE__*/function (LIVE_VIDEO_STATUS) {
  LIVE_VIDEO_STATUS["READY"] = "IN_PROGRESS";
  LIVE_VIDEO_STATUS["PENDING"] = "PENDING";
  LIVE_VIDEO_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
  LIVE_VIDEO_STATUS["SCHEDULED"] = "SCHEDULED";
  LIVE_VIDEO_STATUS["FINISHED"] = "FINISHED";
  return LIVE_VIDEO_STATUS;
}({});
//# sourceMappingURL=live-statuses.js.map